export const set = (key: string, value: string): void => {
  typeof window !== 'undefined' &&
    globalThis.window?.sessionStorage &&
    globalThis.window?.sessionStorage.setItem(key, value)
}

export const get = (key: string): string => {
  return (
    (typeof window !== 'undefined' &&
      globalThis.window?.sessionStorage &&
      globalThis.window?.sessionStorage.getItem(key)) ||
    ''
  )
}

export const remove = (key: string): void => {
  typeof window !== 'undefined' &&
    globalThis.window?.sessionStorage &&
    globalThis.window?.sessionStorage.removeItem(key)
}
